import React, { useCallback, useEffect, useRef, useState } from "react";
import Select from "react-select";
import { Bars, Circles } from "react-loader-spinner";
import nodata from "../../Assets/Image/admin/nodata.png";
import user from "../../Assets/Image/admin/user.png";
import view from "../../Assets/Image/admin/view.png";
import edit from "../../Assets/Image/admin/edit.png";
import deletes from "../../Assets/Image/admin/delete.png";
import FormSelect from "../../Base-Component/FormSelect/FormSelect";
import add from "../../Assets/Image/admin/add.png";
import { useNavigate } from "react-router-dom";
import Dialog from "../../Base-Component/Dialog/Dialog";
import { ChevronDown, ChevronUp, CircleX, Upload } from "lucide-react";
import close from "../../Assets/Image/admin/close.png";
import { IMG_URL, LIST_LANGUAGES_API } from "../../Services/Api";
import noImage from "../../Assets/Image/admin/user.png";
import toast from "react-hot-toast";
import Cookies from "js-cookie";
import {
  addWhatsNew,
  deleteWhatsNew,
  getCategoryList,
  getWhatsNew,
  updatedWhatsNew,
} from "../../Services/ApiServices";
import axios from "axios";
import SunEditor from "suneditor-react";
import DOMPurify from "dompurify";
import PropTypes from "prop-types";
import "suneditor/dist/css/suneditor.min.css";
import Cropper from "react-easy-crop";

function WhatsNew() {
  const navigate = useNavigate();
  const scrollRef = useRef(null);
  const imageRef = useRef(null);

  const [selectedOption, setSelectedOption] = useState(null);
  const [isDragging, setIsDragging] = useState(false);
  const [loader, setLoader] = useState(false);
  const [isModalOpens, setModalOpens] = useState(false);
  const [isAddNews, setIsAddNews] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [cropModal, setCropModal] = useState(false);
  const [cropImg, setCropImg] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const [selectStatus, setSelectStatus] = useState("all");
  const [image, setImage] = useState("");
  const [img, setImg] = useState("");
  const [totalPage, setTotalPage] = useState("1");
  const [newsId, setNewsId] = useState("");
  const [isIndex, setIsIndex] = useState("");
  const [descriptionData, setDescriptionData] = useState("");

  const [pageNo, setPageNo] = useState(1);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);

  const [formValue, setFormValue] = useState({});
  const [newImge, setNewImge] = useState({});

  const [listLanguages, setListLanguages] = useState([]);
  const [categoryData, setCategoryData] = useState([]);

  const [userData, setUserData] = useState([]);

  const handleLanguages = () => {
    axios
      .get(LIST_LANGUAGES_API)
      .then((res) => {
        const data = res.data.islanguage;
        setListLanguages(data);
      })
      .catch((err) => {
        if (err?.response?.status == 401) {
          Cookies.remove("e_learning_token");
          navigate("/login");
        } else {
          toast.error(err?.response?.data?.message);
        }
      });
  };

  useEffect(() => {
    handleLanguages();
  }, []);

  const handleCategoryList = () => {
    setLoader(true);
    getCategoryList()
      .then((res) => {
        const data = res.data.data;
        setCategoryData(data);
        const option = data?.map((item) => ({
          label: (
            <div className="flex items-center p-1 uppercase">
              <img
                src={
                  item.category_image ? IMG_URL + item.category_image : noImage
                }
                className="w-14 h-14 rounded-md object-cover mr-2"
              />
              {item.category_name || ""}
            </div>
          ),
          value: item.id,
          id: item.category_name,
        }));

        if (option?.length > 0) {
          setSelectedOption(option[0]);
        }
        setLoader(false);
      })
      .catch((err) => {
        if (err?.response?.status == 401) {
          Cookies.remove("e_learning_token");
          navigate("/login");
        } else {
          toast.error(err?.response?.data?.message);
        }
        setLoader(false);
      });
  };

  const handleNewsList = (data) => {
    setLoader(true);
    if (selectStatus == "all") {
      let obj = {
        category_id: data,
        page: pageNo,
      };
      getWhatsNew(obj)
        .then((res) => {
          const data = res.data.data;
          setUserData(data);
          setTotalPage(res?.data?.totalPages);
          setLoader(false);
        })
        .catch((err) => {
          if (err?.response?.status == 401) {
            Cookies.remove("e_learning_token");
            navigate("/login");
          } else {
            toast.error(err?.response?.data?.message);
          }
          setLoader(false);
        });
    } else {
      let obj = {
        category_id: data,
        language_id: selectStatus,
        page: pageNo,
      };
      getWhatsNew(obj)
        .then((res) => {
          const data = res.data.data;
          setUserData(data);
          setTotalPage(res?.data?.pagination?.totalPages);
          setLoader(false);
        })
        .catch((err) => {
          if (err?.response?.status == 401) {
            Cookies.remove("e_learning_token");
            navigate("/login");
          } else {
            toast.error(err?.response?.data?.message);
          }
          setLoader(false);
        });
    }
  };

  useEffect(() => {
    if (selectedOption) {
      handleNewsList(selectedOption.value);
    }
  }, [selectedOption, selectStatus, pageNo]);

  useEffect(() => {
    handleCategoryList();
  }, []);

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      minHeight: "50px",
      height: "50px",
      border: "none",
      outline: "0px",
      boxShadow: "none",
      borderRadius: "8px",
      "&:hover": {
        border: "none",
      },
      "&:focus": {
        border: "none",
        boxShadow: "none",
      },
    }),
    valueContainer: (provided) => ({
      ...provided,
      height: "50px",
      padding: "0 8px",
      border: "0px",
      outline: "0px",
    }),
    input: (provided) => ({
      ...provided,
      margin: "0",
      padding: "0",
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: "50px",
      border: "0px",
      outline: "0px",
    }),
    option: (provided, state) => ({
      ...provided,
      color: state.isSelected ? "white" : "black",
      cursor: "pointer",
      backgroundColor: state.isSelected
        ? "#e29c2995"
        : state.isFocused
          ? "#e29c2940"
          : "white",
      ":active": {
        backgroundColor: "#e29c2910",
        color: "white",
      },
    }),
    singleValue: (provided, state) => {
      const opacity = state.isDisabled ? 0.5 : 1;
      const transition = "opacity 300ms";
      return {
        ...provided,
        opacity,
        transition,
        display: "flex",
        alignItems: "center",
      };
    },
  };

  const startDragging = (e) => {
    setIsDragging(true);
    setStartX(e.pageX - scrollRef.current.offsetLeft);
    setScrollLeft(scrollRef.current.scrollLeft);
    document.body.style.userSelect = "none";
  };

  const stopDragging = () => {
    setIsDragging(false);
    document.body.style.userSelect = "";
  };

  const onDragging = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - scrollRef.current.offsetLeft;
    const walk = (x - startX) * 2;
    scrollRef.current.scrollLeft = scrollLeft - walk;
  };

  const renderPaginationButtonss = () => {
    const maxPagesToShow = 3;
    const buttons = [];
    const startPage = Math.max(1, pageNo - Math.floor(maxPagesToShow / 2));
    const endPage = Math.min(totalPage, startPage + maxPagesToShow - 1);

    for (let i = startPage; i <= endPage; i++) {
      buttons.push(
        <button
          key={i}
          onClick={() => handlePageChange(i)}
          className={
            i === pageNo
              ? "px-4 py-[7px] mx-1 bg-[#EA5F5F1A] rounded-md text-[#EA5F5F]"
              : "px-4 py-[7px] mx-1 text-[#EA5F5F]"
          }
        >
          {i}
        </button>
      );
    }
    return buttons;
  };

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPage) {
      setPageNo(page);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    if (isUpdate) {
      const formData = new FormData();
      formData.append("blog_id", formValue.id);
      formData.append("title", formValue.title);
      if (descriptionData) {
        formData.append("description", descriptionData);
      }
      formData.append("language_id", formValue.language_id);
      formData.append("category_id", formValue.category_id);
      if (image) {
        formData.append("blog_image", image);
      }
      if (descriptionData == "<p><br></p>") {
        toast.error("Please enter description");
        setIsLoading(false);
      } else {
        updatedWhatsNew(formData)
          .then((res) => {
            toast.success(res.data.message);
            setIsAddNews(false);
            handleNewsList(selectedOption.value);
          })
          .catch((err) => {
            if (err?.response?.status == 401) {
              Cookies.remove("e_learning_token");
              navigate("/login");
            } else {
              toast.error(err?.response?.data?.message);
            }
            setIsLoading(false);
          });
      }
    } else {
      const formData = new FormData();
      formData.append("title", formValue.title);
      formData.append("description", descriptionData);
      formData.append("language_id", formValue.language_id);
      formData.append("category_id", formValue.category_id);
      if (image) {
        formData.append("blog_image", image);
      }

      for (let [key, value] of formData.entries()) {
        console.log(`${key}:`, value);
      }

      if (!image) {
        toast.error("Please Select Image");
        setIsLoading(false);
      } else if (descriptionData == "<p><br></p>") {
        toast.error("Please enter description");
        setIsLoading(false);
      } else {
        addWhatsNew(formData)
          .then((res) => {
            toast.success(res.data.message);
            setIsAddNews(false);
            handleNewsList(selectedOption.value);
          })
          .catch((err) => {
            if (err?.response?.status == 401) {
              Cookies.remove("e_learning_token");
              navigate("/login");
            } else {
              toast.error(err?.response?.data?.message);
            }
            setIsLoading(false);
          });
      }
    }
  };

  const handleFile = (e) => {
    setImage(e.target.files[0]);
    let imageData = URL.createObjectURL(e.target.files[0]);
    setImg(imageData);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValue({ ...formValue, [name]: value });
  };

  const handleEdit = (data) => {
    setIsUpdate(true);
    setFormValue(data);
    setDescriptionData(data.description);
    setIsAddNews(true);
    setIsLoading(false);
    setIsOpen(false);
    if (data.blog_image) {
      setImg(IMG_URL + data.blog_image);
    } else {
      setImg("");
    }
    setImage("");
    setCropImg(false);
  };

  const handleDelete = (e) => {
    e.preventDefault();
    setIsLoading(true);

    let obj = {
      blog_id: newsId,
    };
    deleteWhatsNew(obj)
      .then((res) => {
        toast.success(res.data.message);
        setIsDelete(false);
        const data = [...userData];
        data.splice(isIndex, 1);
        setUserData(data);
      })
      .catch((err) => {
        if (err?.response?.status == 401) {
          Cookies.remove("e_learning_token");
          navigate("/login");
        } else {
          toast.error(err?.response?.data?.message);
        }
        setIsLoading(false);
      });
  };

  const HtmlContent = ({ htmlString }) => {
    const sanitizedHtml = DOMPurify.sanitize(htmlString);
    const style = `
          ol {
            margin: 0;
            padding: 0;
            list-style-type: decimal; /* Numbering */
            padding-left: 20px; /* Adjust left padding as needed */
          }
          ul {
            margin: 0;
            padding: 0;
            list-style-type: disc; /* Bullets */
            padding-left: 20px; /* Adjust left padding as needed */
          }
          li {
            margin: 0;
            padding: 0;
            line-height: 1.5;
          }
          a {
            color: blue;
          }
        `;

    return (
      <div
        dangerouslySetInnerHTML={{
          __html: `<style>${style}</style>${sanitizedHtml}`,
        }}
      />
    );
  };

  HtmlContent.propTypes = {
    htmlString: PropTypes.string.isRequired,
  };

  const handleAdd = () => {
    setIsAddNews(true);
    setFormValue({});
    setIsUpdate(false);
    setDescriptionData("");
    setIsLoading(false);
    setIsOpen(false);
    setImage("");
    setImg("");
    setCropImg(false);
  };

  const handleDeleteView = (id, index) => {
    setIsDelete(true);
    setNewsId(id);
    setIsIndex(index);
    setIsLoading(false);
  };

  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const getCroppedImage = useCallback(async () => {
    try {
      const croppedImage = await getCroppedImg(
        img ? img : IMG_URL + newImge.blog_image,
        croppedAreaPixels
      );
      console.log("Cropped Image: ", croppedImage);
    } catch (e) {
      console.error("Crop failed:", e);
    }
  }, [croppedAreaPixels, img, IMG_URL, newImge]);

  const getCroppedImg = (imageSrc, croppedAreaPixels) => {
    return new Promise((resolve, reject) => {
      const image = new Image();
      image.src = imageSrc;
      image.setAttribute("crossOrigin", "anonymous");

      image.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        canvas.width = croppedAreaPixels.width;
        canvas.height = croppedAreaPixels.height;

        ctx.drawImage(
          image,
          croppedAreaPixels.x,
          croppedAreaPixels.y,
          croppedAreaPixels.width,
          croppedAreaPixels.height,
          0,
          0,
          croppedAreaPixels.width,
          croppedAreaPixels.height
        );

        const base64Image = canvas.toDataURL("image/jpeg");
        setImg(base64Image);

        fetch(base64Image)
          .then((res) => res.blob())
          .then((blob) => {
            const file = new File([blob], "cropped-image.jpg", {
              type: "image/jpeg",
            });
            setImage(file);
          });
      };

      image.onerror = (error) => {
        reject(error);
      };
    });
  };

  const handleEditorChange = (content) => {
    const updatedContent = content.replace(
      /<a(?![^>]*\btarget="_blank")/g,
      '<a target="_blank"'
    );
    setDescriptionData(updatedContent);
  };

  const stripHtml = (html) => {
    if (!html) return "";
    const tmp = document.createElement("div");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
  };

  return (
    <div className="md:m-4 m-1 fontNew">
      {/* Same width & angle as Information: grid lg:col-span-6, rounded-lg */}
      <div className="grid grid-cols-12 gap-6 mb-6">
        <div className="lg:col-span-6 col-span-12">
          <Select
            value={selectedOption}
            onChange={(option) => {
              setSelectedOption(option);
              setPageNo(1);
            }}
            options={categoryData?.map((item) => ({
              label: (
                <div className="flex items-center p-1 uppercase">
                  <img
                    src={
                      item.category_image
                        ? IMG_URL + item.category_image
                        : noImage
                    }
                    className="w-14 h-14 rounded-md object-cover mr-2"
                  />
                  {item.category_name || ""}
                </div>
              ),
              value: item.id,
              id: item.category_name,
            }))}
            placeholder="Select Category"
            className="bg-white py-2 outline-0 rounded-lg"
            styles={customStyles}
          />
        </div>
        <div className="lg:col-span-6 col-span-12 flex flex-wrap items-center justify-end gap-3">
          <div className="xl:w-40 sm:w-36 w-full">
            <FormSelect
              id="category"
              name="fuel_type"
              value={selectStatus}
              onChange={(e) => {
                setSelectStatus(e.target.value);
                setPageNo(1);
              }}
              className="sm:me-3 sm:mb-0 mb-0 ps-5 pl-0 pb-0 pt-0 me-0 select-arrow-hidden text-sm rounded-[8px] font-medium xl:w-40 sm:w-36 w-full h-10 outline-none"
            >
              <option value="all">All</option>
              {listLanguages.map((item, index) => {
                return (
                  <option key={index} value={item.id}>
                    {item.Language_name}
                  </option>
                );
              })}
            </FormSelect>
          </div>
          <button
            onClick={handleAdd}
            className="bg-[#e29c29] text-white flex items-center py-2 px-3 rounded-lg whitespace-nowrap"
          >
            <img src={add} className="w-6 mr-2" alt="" />
            Add What's New
          </button>
        </div>
      </div>

      <div className="grid grid-cols-12">
        {loader ? (
          <div className="flex justify-center items-center col-span-12 h-[70vh]">
            <Bars
              height="35"
              width="35"
              color="#e29c29"
              ariaLabel="bars-loading"
              wrapperStyle={{}}
              wrapperClass=""
              visible={true}
            />
          </div>
        ) : (
          <>
            {userData.length === 0 ? (
              <div className="col-span-12 h-[50vh] justify-center flex items-center">
                <img src={nodata} className="w-28" alt="No data" />
              </div>
            ) : (
              <>
                <div className="col-span-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 lg:gap-8">
                  {userData.map((item, index) => (
                    <div
                      key={index}
                      className="bg-white rounded-lg shadow-md overflow-hidden border border-gray-100 flex flex-col"
                    >
                      {/* 1. Image (top) - much shorter */}
                      <div className="w-full h-62 bg-gray-100 flex-shrink-0">
                        <img
                          src={
                              item.blog_image
                              ? IMG_URL + item.blog_image
                              : user
                          }
                          alt={item.title || ""}
                          className="w-full h-full object-cover"
                        />
                      </div>
                      {/* 2. Title */}
                      <div className="px-3 pt-2">
                        <h3 className="text-sm font-semibold text-gray-900 line-clamp-2">
                          {item.title || ""}
                        </h3>
                      </div>
                      {/* 3. Description - fewer lines, less padding */}
                      <div className="px-3 py-1.5 flex-1 min-h-0">
                        <p className="text-xs text-gray-600 line-clamp-2">
                          {stripHtml(item.description || "") || "—"}
                        </p>
                      </div>
                      {/* 4. View, Update, Delete icons (bottom) */}
                      <div className="px-3 pb-3 pt-1.5 flex items-center justify-center gap-3 border-t border-gray-100">
                        <div
                          onClick={() => {
                            setModalOpens(true);
                            setFormValue(item);
                            setIsLoading(false);
                          }}
                          className="cursor-pointer p-1 rounded hover:bg-gray-100 transition-colors"
                          title="View"
                        >
                          <img src={view} className="w-8 h-8" alt="View" />
                        </div>
                        <div
                          onClick={() => handleEdit(item)}
                          className="cursor-pointer p-1 rounded hover:bg-gray-100 transition-colors"
                          title="Update"
                        >
                          <img src={edit} className="w-8 h-8" alt="Update" />
                        </div>
                        <div
                          onClick={() => handleDeleteView(item.id, index)}
                          className="cursor-pointer p-1 rounded hover:bg-gray-100 transition-colors"
                          title="Delete"
                        >
                          <img
                            src={deletes}
                            className="w-8 h-8"
                            alt="Delete"
                          />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="col-span-12 flex flex-wrap items-center sm:justify-end justify-center bg-white py-4 sm:px-8 px-0 rounded-lg mt-10">
                  <div className="flex items-center cursor-pointer">
                    <p
                      onClick={() => handlePageChange(pageNo - 1)}
                      disabled={pageNo === 1}
                    >
                      Previous
                    </p>
                    <div className="flex items-center mx-6">
                      {renderPaginationButtonss()}
                    </div>
                    <p
                      onClick={() => handlePageChange(pageNo + 1)}
                      disabled={pageNo === totalPage}
                    >
                      Next
                    </p>
                  </div>
                </div>
              </>
            )}
          </>
        )}
      </div>

      <Dialog open={isAddNews} onClose={() => setIsAddNews(false)} size="xl">
        <Dialog.Panel>
          <Dialog.Description className="rounded-none border-2 border-white">
            <div className="p-4 sm:w-auto w-[330px] md:h-[700px] h-[500px] overflow-auto fontNew">
              <h4 className="text-lg font-semibold mb-2">
                {isUpdate ? "Update" : "Add"} What's New
              </h4>
              <form onSubmit={handleSubmit}>
                <div className="grid grid-cols-12 ">
                  <div className="col-span-12 flex items-center mx-2 my-2">
                    <div className="w-full p-5 border-2 border-dashed rounded-md shadow-sm border-slate-300/60 dark:border-darkmode-400">
                      <div className="relative cursor-pointer h-52 w-full image-fit flex justify-center items-start">
                        {img || formValue.blog_image ? (
                          <>
                            <img
                              className="rounded-md h-52"
                              alt="Midone - HTML Admin Template"
                              src={
                                img
                                  ? img
                                  : formValue.blog_image
                                    ? IMG_URL + formValue.blog_image
                                    : noImage
                              }
                            />
                            {img ? (
                              <div
                                className="w-6 h-6"
                                onClick={() => setImg("")}
                              >
                                <img
                                  src={close}
                                  className="w-6 h-6 -ms-4 -mt-2 relative"
                                  alt=""
                                />
                              </div>
                            ) : (
                              ""
                            )}
                          </>
                        ) : (
                          <p className="flex justify-center items-center h-52">
                            Image Not Found{" "}
                          </p>
                        )}
                      </div>
                      <div className="flex justify-center items-center mt-4">
                        <div className="relative flex items-center justify-center cursor-pointer">
                          <Upload className="text-blue-600" size={18} />
                          <h4 className="mr-1 text-blue-600 ml-2 sm:text-base text-sm">
                            Upload News Image
                          </h4>{" "}
                          <input
                            id="horizontal-form-1"
                            type="file"
                            className="absolute top-0 left-0 w-full h-full opacity-0"
                            accept="image/*"
                            onChange={handleFile}
                          />
                        </div>
                        <div>
                          {img && !cropImg ? (
                            <b
                              className="cursor-pointer underline sm:text-base text-sm"
                              onClick={(e) => setCropModal(true)}
                            >
                              Crop Image
                            </b>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-span-12 md:mx-2 mx-0 my-2">
                    <h4 className="text-sm font-medium mb-3">
                      Select Language
                    </h4>
                    <select
                      name="language_id"
                      required
                      value={formValue.language_id}
                      onChange={handleChange}
                      className="select-arrow-hidden w-full outline-[#e1c595] border-2 px-4 py-3 rounded-md"
                    >
                      <option label="Select Language"></option>
                      {listLanguages.map((item, index) => {
                        return (
                          <option key={index} value={item.id}>
                            {item.Language_name}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                  <div className="col-span-12 md:mx-2 mx-0 my-3">
                    <h4 className="text-sm font-medium mb-3">
                      Select Category
                    </h4>
                    <select
                      name="category_id"
                      required
                      value={formValue.category_id || ""}
                      onChange={handleChange}
                      className="select-arrow-hidden w-full outline-[#e1c595] border-2 px-4 py-3 rounded-md"
                    >
                      <option label="Select Category"></option>
                      {categoryData.map((item, index) => {
                        return (
                          <option key={index} value={item.id}>
                            {item.category_name}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                  <div className="col-span-12 md:mx-2 mx-0 my-2">
                    <h4 className="text-sm font-medium mb-3">Title</h4>
                    <input
                      type="text"
                      name="title"
                      value={formValue.title || ""}
                      onChange={handleChange}
                      required
                      className="border-2 px-4 py-3 rounded-md w-full outline-[#e1c595]"
                      placeholder="Enter"
                    />
                  </div>
                  <div className="col-span-12 md:mx-2 mx-0 my-2">
                    <h4 className="text-sm font-medium mb-3">
                      News Description
                    </h4>
                    <SunEditor
                      setContents={descriptionData || ""}
                      onChange={handleEditorChange}
                      height="280px"
                      setOptions={{
                        buttonList: [
                          ["undo", "redo"],
                          ["fontSize"],
                          ["bold", "underline", "italic"],
                          ["fontColor", "hiliteColor"],
                          ["align", "list"],
                          ["link", "image"],
                        ],
                      }}
                      name="my-editor"
                      required
                    />
                  </div>
                </div>
                <div className="mt-6 flex justify-end">
                  <button
                    type="button"
                    onClick={() => setIsAddNews(false)}
                    className="bg-[#EF5F5F] py-2 px-7 text-white rounded-lg mr-5"
                  >
                    Close
                  </button>
                  <button
                    type="submit"
                    disabled={isLoading}
                    className="bg-[#00987C] text-white h-[45px] w-30 rounded-lg"
                  >
                    {isLoading ? (
                      <div className="flex justify-center">
                        <Circles
                          width={25}
                          height={25}
                          color="#fff"
                          ariaLabel="circles-loading"
                          wrapperStyle={{}}
                          visible={true}
                          wrapperClass=""
                        />
                      </div>
                    ) : (
                      `${isUpdate ? "Update" : "Add"}`
                    )}
                  </button>
                </div>
              </form>
            </div>
          </Dialog.Description>
        </Dialog.Panel>
      </Dialog>

      <Dialog
        open={isModalOpens}
        onClose={() => setModalOpens(false)}
        size="xl"
      >
        <Dialog.Panel>
          <Dialog.Description className="rounded-none border-2 border-white">
            <div className="sm:w-auto w-[330px] md:h-[700px] h-[500px] overflow-auto">
              <div className="flex justify-between border-b p-5">
                <h4 className="text-lg font-medium">What's New Details</h4>
                <CircleX
                  color="gray"
                  size={28}
                  onClick={() => setModalOpens(false)}
                  className="cursor-pointer"
                />
              </div>
              <div className="p-5 space-y-3">
                <div className="flex justify-center my-3">
                  <img
                    src={
                        formValue.blog_image
                        ? IMG_URL + formValue.blog_image
                        : ""
                    }
                    className="w-auto h-52"
                    alt=""
                  />
                </div>
                <div>
                  <h4>Title :</h4>
                  <h3 className="text-xl break-word font-medium">
                    {formValue.title || ""}
                  </h3>
                </div>
                {/* <div className="my-3">
                  <h4>User Role :</h4>
                  <h3 className="text-base font-medium flex flex-wrap items-center">
                    {formValue &&
                      formValue?.informationRoles?.map((item, index) => (
                        <span key={index}>
                          {item?.userRole?.role_name}
                          {index < formValue.informationRoles.length - 1 && (
                            <span>,&nbsp;</span>
                          )}
                        </span>
                      ))}
                  </h3>
                </div> */}

                <div>
                  <h4>Description :</h4>
                  <div className="font-medium">
                    <HtmlContent htmlString={formValue.description || ""} />
                  </div>
                </div>
              </div>
            </div>
          </Dialog.Description>
        </Dialog.Panel>
      </Dialog>

      <Dialog open={isDelete} onClose={() => setIsDelete(false)} size="2xl">
        <Dialog.Panel>
          <Dialog.Description className="rounded-none border-2 border-white">
            <div className="flex justify-center text-center my-4 sm:px-16 px-4 fontNew">
              <div>
                <h4 className="text-xl font-semibold text-black mt-6">
                  Delete What's New?
                </h4>
                <p className="text-sm text-gray-500 my-3">
                  Are you sure you want to delete this what's New?
                </p>
                <div className="mt-13 flex items-center mb-5">
                  <button
                    className="bg-[#F4F5FA] h-[50px] sm:w-36 w-30 text-sm rounded-xl sm:mx-3 mx-2"
                    onClick={() => setIsDelete(false)}
                  >
                    Close
                  </button>
                  <button
                    disabled={isLoading}
                    className="bg-[#e29c29] h-[50px] sm:w-36 w-30 text-sm rounded-xl sm:mx-3 mx-2 text-white"
                    onClick={handleDelete}
                  >
                    {isLoading ? (
                      <div className="flex justify-center">
                        <Circles
                          width={25}
                          height={25}
                          color="#fff"
                          ariaLabel="circles-loading"
                          wrapperStyle={{}}
                          visible={true}
                          wrapperClass=""
                        />
                      </div>
                    ) : (
                      "Yes, Delete"
                    )}
                  </button>
                </div>
              </div>
            </div>
          </Dialog.Description>
        </Dialog.Panel>
      </Dialog>

      <Dialog
        open={cropModal}
        onClose={() => setCropModal(false)}
        initialFocus={imageRef}
        size="lg"
      >
        <Dialog.Panel className=" w-full mx-auto bg-white px-5 pt-2">
          <Dialog.Title className="flex justify-between text-lg font-medium">
            <h4>Crop Image</h4>
            <CircleX
              color="gray"
              size={28}
              onClick={() => setCropModal(false)}
              className="cursor-pointer"
            />
          </Dialog.Title>
          <Dialog.Description className="mt-4">
            <div className="relative w-full h-[400px]">
              <Cropper
                image={img ? img : IMG_URL + newImge.blog_image}
                crop={crop}
                zoom={zoom}
                aspect={297 / 210}
                onCropChange={setCrop}
                onZoomChange={setZoom}
                onCropComplete={onCropComplete}
              />
            </div>
          </Dialog.Description>
          <Dialog.Footer className="flex justify-end mt-4">
            <button
              className="w-24 bg-[#00987C] px-4 py-2 rounded-lg text-white"
              type="button"
              onClick={() => {
                getCroppedImage();
                setCropModal(false);
              }}
            >
              Submit
            </button>
          </Dialog.Footer>
        </Dialog.Panel>
      </Dialog>
    </div>
  );
}

export default WhatsNew;
